import { createFileRoute, redirect } from "@tanstack/react-router";
import { SUPPORT_TOOLS } from "~/modules/SupportTools/constants";
import { isSupportToolsEnabled } from "~/modules/SupportTools/utils";

export const Route = createFileRoute("/_protected/(org)/_org-layout/orgs/$orgId/support-tools/$tool")({
  beforeLoad: ({ params }) => {
    const { orgId, tool } = params;

    // Check if Support Tools feature is enabled
    if (!isSupportToolsEnabled()) {
      throw redirect({ to: "/orgs/$orgId", params: { orgId } });
    }

    // Validate that the tool exists
    const toolExists = SUPPORT_TOOLS.some((t) => t.path === tool);

    if (!toolExists) {
      // Redirect to org support tools home if tool doesn't exist
      throw redirect({ to: "/orgs/$orgId/support-tools", params: { orgId } });
    }
  },
  component: () => {
    const { tool } = Route.useParams();

    // Find the tool and get its component (guaranteed to exist by beforeLoad validation)
    const toolConfig = SUPPORT_TOOLS.find((t) => t.path === tool)!;
    const ToolComponent = toolConfig.component;

    return <ToolComponent />;
  },
});
